import ReactDOM from 'react-dom/client';
import { initNetworkLogger } from './utils/network-logger';
import { initConsoleLogger } from './utils/console-logger';
import App from './App';

const suppressDevConsoleNoise = () => {
  if (!import.meta.env.DEV) return;

  const suppressedLogExact = new Set(['[vite] connecting...', '[vite] connected.']);
  const suppressedLogPrefixes = [
    '[versionCheck]',
    '[VersionCheckContext]',
    '[WebSocketManager]',
    '[SharedWebSocket]',
    '[TabLeaderElection',
  ];
  const suppressedInfoPrefixes = ['Download the React DevTools'];
  const suppressedWarnFragments = [
    'React Router Future Flag Warning',
    '[versionCheck]',
    '[SharedWebSocket]',
    '[WebSocketManager]',
    '[TabLeaderElection]',
  ];

  const patchConsole = (method: 'log' | 'info' | 'warn', shouldSkip: (...args: unknown[]) => boolean) => {
    const original = console[method].bind(console) as (...args: unknown[]) => void;
    (console as Record<typeof method, (...args: unknown[]) => void>)[method] = (...args: unknown[]) => {
      if (shouldSkip(...args)) return;
      original(...args);
    };
  };

  patchConsole('log', (...args: unknown[]) => {
    if (typeof args[0] !== 'string') return false;
    const msg = args[0] as string;
    return suppressedLogExact.has(msg) || suppressedLogPrefixes.some((p) => msg.startsWith(p));
  });
  patchConsole('info', (...args: unknown[]) => typeof args[0] === 'string' && suppressedInfoPrefixes.some((prefix) => (args[0] as string).startsWith(prefix)));
  patchConsole('warn', (...args: unknown[]) => typeof args[0] === 'string' && suppressedWarnFragments.some((fragment) => (args[0] as string).includes(fragment)));
};

suppressDevConsoleNoise();

// Init loggers AFTER console suppression (so filtered noise doesn't fill the buffer)
initNetworkLogger();
initConsoleLogger();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);
